export const CLOSE_ICON_SIZE = '24px'

export const LOGIN_TITLE = 'Who are you logging in as?'

export const SIGNUP_TITLE = 'Who are you signing up as?'

export const DISCOUNTS_TITLE = `View discounts for`
